<template>
    <!-- 账单支付  -->
    <sub-page :title="title" :subtitle="subtitle" :description="description" :button-text="buttonText" :bg="bg"
        :right-bg="rightBg" :right-bg2="rightBg2" :partition="[7, 5]" />

</template>

<script>
import SubPage from "./components/SubPage.vue";
export default {
    name: 'bill',
    components: {
        SubPage
    },
    data() {
        return {
            rightBg: "/img/pay/0--32.png",
            rightBg2: "/img/pay/0--33.png",
            bg: "/img/pay/0-_BG-3.png",
        }
    },
    computed: {
        title() {
            return this.$t('bill.title');
        },
        subtitle() {
            return this.$t('bill.subtitle');
        },
        description() {
            return [this.$t('bill.description')];
        },
        buttonText() {
            return this.$t('common.buttonText');
        },
    }
}
</script>
